import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { ActivatedRoute, Router } from '@angular/router';
import { IExam, IExaminationGroup, IExamQuestionBank, IQuestionBankDto } from 'src/app/interface/dto';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { Util } from 'src/app/services/Util';
import { GridUtil } from 'src/app/components/grid/GridUtil';
import { QuestionBankService } from 'src/app/questions-bank/question-bank.service';
import { CandidateService } from 'src/app/services/candidate-service.service';
import { QuillEditorComponent } from 'ngx-quill';
import { take } from 'rxjs';
import { PopoverService } from 'src/@vex/components/popover/popover.service';
import { GenericConfirmComponent } from 'src/app/shared-layout/generic-confirm/generic-confirm.component';
declare const $: any;
import * as bootstrap from 'bootstrap';
import { AuthService } from 'src/app/services/http-services/authservice.service';

@Component({
  selector: 'app-create-examination',
  templateUrl: './create-examination.component.html',
  styleUrls: ['./create-examination.component.scss']
})
export class CreateExaminationComponent implements OnInit, AfterViewInit {
  populateDefaultEmailMessage($event: any) {
    let isChecked = $event.target.checked;
    if (isChecked) {
      this.candidateService.defaultEmailMessage(this.mode == 'default').then((res: any) => {
        this.exam.emailMessage = res.message;
        this.editor.quillEditor.clipboard.dangerouslyPasteHTML(this.exam.emailMessage);
      });
    } else {
      this.exam.emailMessage = "";
      this.editor.quillEditor.clipboard.dangerouslyPasteHTML(this.exam.emailMessage);
    }
  }

  text = 'Create'
  exam: IExam = examDefault;
  modelError: string[] = []
  mode = "";
  disableAll = false;
  showWebTestQuestionBank = false;
  examGroupsList: IExaminationGroup[] = [];
  questionBanks: IQuestionBankDto[] = [];
  allQuestionBanks: IQuestionBankDto[] = [];
  erroredFields: string[] = [];
  oldExaminationType: string;
  @ViewChild('editor') editor: QuillEditorComponent;
  quill: any = {};
  toast = {
    visible: false,
    x: 0,
    y: 0
  };
  constructor(private examsevice: ExamService, private snackBar: SnackbarService, private actRoute: ActivatedRoute, private popoverService: PopoverService,
    private questionBankService: QuestionBankService, private candidateService: CandidateService, private router: Router,private authService: AuthService) { }

  async ngOnInit() {
    this.examGroupsList = await this.examsevice.getExamGroupsLookup();
    const selectedExam = Array.isArray(this.examsevice.selectedExams) && this.examsevice.selectedExams.length > 0 ? this.examsevice.selectedExams[0] : null;
    if (selectedExam) {
      this.actRoute.paramMap.subscribe(params => {
        let examid = JSON.parse(params.get("examid")) as number;
        if (selectedExam.id === examid) {
          this.text = 'Update'
          this.exam = selectedExam;
          const localStartDate = Util.convertUTCToTimezone(this.exam.examStartDate, this.authService.user.timezoneOffset);
          this.exam.examStartDate = Util.toLocalInputValue(localStartDate) as any;
          const localSEndDate = Util.convertUTCToTimezone(this.exam.examEndDate, this.authService.user.timezoneOffset);
          this.exam.examEndDate = Util.toLocalInputValue(localSEndDate) as any;
          if (this.exam.selfRegistrationEndDate && this.exam.selfRegistrationEndDate > new Date(0)) { 
            const localSelfRegEndDate = Util.convertUTCToTimezone(this.exam.selfRegistrationEndDate, this.authService.user.timezoneOffset);
            this.exam.selfRegistrationEndDate = Util.toLocalInputValue(localSelfRegEndDate) as any;
          }
          if (this.exam.adminStartTime && this.exam.adminStartTime > new Date(0)) { 
            const localAdminStartTime = Util.convertUTCToTimezone(this.exam.adminStartTime, this.authService.user.timezoneOffset);
            this.exam.adminStartTime = Util.toLocalInputValue(localAdminStartTime) as any;
          }
         
        }
      });
      this.actRoute.queryParams.subscribe(params => {
        this.mode = params['mode'] || '';
        if (this.mode == 'view-all') {
          this.disableAll = true;
          this.text = 'View'
        }
        if (this.mode == 'copy') {
          this.disableAll = false;
          this.text = 'Create'
          this.exam.id = 0; // Reset ID for new exam creation
        }
      });


      switch (this.exam.examinationType) {
        case 'Short Answer Question':
          this.exam.examinationType = 'SAQ';
          break;
        case 'Multiple-Choice':
          this.exam.examinationType = 'MultipleChoice';
          break;
        case 'Not Set':
          this.exam.examinationType = 'NotSet';
          break;
      }

      if (this.exam.useQuestionBank) {
        await this.getQuestionBanks();
      }

      this.oldExaminationType = this.exam.examinationType;

    }
  }

  ngAfterViewInit() {
    document
      .querySelectorAll('[data-bs-toggle="tooltip"]')
      .forEach(el => new bootstrap.Tooltip(el));

    const tabButtons = document.querySelectorAll('.nav-link');

    tabButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        tabButtons.forEach(b => b.classList.remove('bg-success', 'text-white'));
        btn.classList.add('bg-success', 'text-white');
      });
    });

    setTimeout(() => {
      this.setErroredFields([
        "examinationName",
        "session",
        "examinationType",
        "duration",
        "numberOfQuestions",
        "maximumNumberOfEssayAnswers",
        "maximumNumberOfSAQAnswers",
        "questionSelectionMode",
        "numberofQuestionsPerCategory",
        "calculatorType",
        "examStartDate",
        "examEndDate",
      ]);
      this.detectFocusClicked({ target: { checked: this.exam.detectFocusLoss } });
      this.focusChange();
      this.requireSecondViewCicked({ target: { checked: this.exam.requireSecondView } });
      this.examRetakeClicked({ target: { checked: this.exam.allowExamRetake } });

    }, 500);

  }

  filterQuestionBanks() {
    if (this.showWebTestQuestionBank || this.exam.psychometricTest) {
      // Show all QBs (both WebTest and Own)
      this.questionBanks = this.allQuestionBanks;
    } else {
      // Show only non-WebTest QBs (Own QB)
      this.questionBanks = this.allQuestionBanks.filter(f => !f.isWebTestBank);
    }

    // Sort alphabetically by name, then by category
    this.questionBanks.sort((a, b) => {
      const nameCompare = a.name.localeCompare(b.name);
      if (nameCompare !== 0) return nameCompare;
      const catA = a.category || '';
      const catB = b.category || '';
      return catA.localeCompare(catB);
    });

  }

  onShowWebTestQuestionBankChange() {
    this.filterQuestionBanks();

    if (this.showWebTestQuestionBank) {
      this.snackBar.success("WebTest Question Bank is now visible.");
    } else {
      this.snackBar.success("WebTest Question Bank has been hidden.");
    }
  }

  detectFocusClicked($event: any) {
    let isChecked = $event.target.checked;
    if (isChecked) {
      this.setErroredFields(["lossOfFocusAction", "permissibleDurationOfLoss", "noOfTimesAllowedForFocusLoss"], false);
    } else {
      this.removeErroredFields(["lossOfFocusAction", "permissibleDurationOfLoss", "lossofFocusReduceTimeActionDuration", "lossofFocusRestartActionLimit", "noOfTimesAllowedForFocusLoss"]);
    }
  }
  focusChange() {
    this.removeErroredFields(["lossofFocusReduceTimeActionDuration", "lossofFocusRestartActionLimit"]);
    switch (this.exam.lossOfFocusAction) {
      case 'ReduceTime':
        this.setErroredFields(["lossofFocusReduceTimeActionDuration"], false);
        break;
      case 'RestartExam':
        this.setErroredFields(["lossofFocusRestartActionLimit"], false);
        break;
    }
  }
  requireSecondViewCicked($event) {
    let isChecked = $event.target.checked;
    if (isChecked) {
      this.setErroredFields(["noSecondViewStreamPolicy"], false);
    } else {
      this.removeErroredFields(["noSecondViewStreamPolicy"]);
    }
  }

  examRetakeClicked($event: any) {
    let isChecked = $event.target.checked;
    if (isChecked) {
      this.setErroredFields(["maxRetake", "answeredQuestionsPercentage", "examinationDurationPercentage"], false);
    } else {
      this.removeErroredFields(["maxRetake", "answeredQuestionsPercentage", "examinationDurationPercentage"]);
    }
  }
  saveExam(origin: any) {
    this.validateModel();

    if (this.mode === 'copy') {
      this.exam.id = 0;
    }

    if (this.modelError && this.modelError.length > 0) {
      return;
    }

    // If duration is 0, show modal before proceeding
    if (this.exam.duration === 0 && !this.exam.psychometricTest) {
      const popover = this.popoverService.open({
        content: GenericConfirmComponent,
        origin: origin,
        width: 2000,
        offsetY: 12,
        data: { message: 'Exam duration is set to 0 minutes. \nAre you sure you want to continue?' },
        position: [
          {
            originX: 'end',
            originY: 'top',
            overlayX: 'end',
            overlayY: 'top'
          },
          {
            originX: 'end',
            originY: 'top',
            overlayX: 'end',
            overlayY: 'top'
          }
        ]
      });

      popover.afterClosed$
        .pipe(take(1))
        .subscribe((result: any) => {
          if (result?.data === true) {
            this.processSave(origin);
          }
        });
      return;
    }

    this.processSave(origin);
  }

  private processSave(origin: any) {
    switch (this.text) {
      case 'Update':
        this.examsevice.updateExam(this.getExamFormData()).then(() => {
          this.snackBar.success('EXAMINATION UPDATED!!');
          this.router.navigate(["/exams"]);
        });
        break;

      case 'Create':
        this.updateExamWithSelectedQuestionBanks();
        this.examsevice.createExam(this.getExamFormData()).then((res: any) => {
          this.snackBar.success('EXAMINATION CREATED!!');
          this.examsevice.setSelectedExam([]);
          GridUtil.setClearGridSelection();
          this.router.navigate(['/exams']).then(() => {
            if (!this.exam.useQuestionBank && !this.exam.questionFile) {
              const popover = this.popoverService.open({
                content: GenericConfirmComponent,
                origin: origin,
                width: 2000,
                offsetY: 12,
                data: { message: `Your exam has been created, but you haven't setup any exam questions yet. \nWould you like to setup questions now?` },
                position: [
                  {
                    originX: 'end',
                    originY: 'top',
                    overlayX: 'end',
                    overlayY: 'top'
                  }, {
                    originX: 'end',
                    originY: 'top',
                    overlayX: 'end',
                    overlayY: 'top'
                  }
                ]
              });
              popover.afterClosed$
                .pipe(take(1))
                .subscribe(async (result: any) => {
                  if (result.data === true) {
                    setTimeout(() => {
                      this.router.navigate(['/exams', res.id, 'questions']);
                    }, 500);
                  }
                });
            }
          });
        });
        break;
    }
  }

  getExamFormData(): FormData {
    const formData = new FormData();
    Object.keys(this.exam).forEach((key) => {
      const value = (this.exam as any)[key];
      if (value === null || value === undefined) {
        formData.append(key, '');
      } else if (key === 'examQuestionBanks') {
        formData.append('examQuestionBanksRaw', JSON.stringify(value));
      }
      else {
        formData.append(key, value);
      }
    });
    return formData;
  }

  onProctorChange(fromRecording: boolean = false) {
    //we want to make sure we record if any proctoring is on
    if (!fromRecording && !this.exam.recording) {
      this.exam.recording = this.exam.liveProctoring || this.exam.aIProctoring || this.exam.facialRecognition;
    }

    if (this.exam.liveProctoring || this.exam.aIProctoring || this.exam.facialRecognition || this.exam.recording) {
      this.setErroredFields(['noPrimaryStreamPolicy'], false);
    } else {
      this.removeErroredFields(['noPrimaryStreamPolicy']);
    }
  }

  async resetQuestionSelectionMode() {
    if (this.exam.examinationType === 'Essay' && !(this.exam.questionSelectionMode === 'All' || this.exam.questionSelectionMode === 'RandomPerQuestionNumber')) {
      this.exam.questionSelectionMode = '';
    }

    if (this.text === 'Create' && this.exam.useQuestionBank) {
      await this.getQuestionBanks();
    }

    this.oldExaminationType = this.exam.examinationType;
  }

  validateModel() {
    this.modelError = [];
    this.erroredFields = [];
    if (this.exam.examinationName == '') {
      this.modelError.push("*Examination Name required");
      this.erroredFields.push('examinationName');
    }
    if (this.exam.session == '') {
      this.modelError.push("*Period required");
      this.erroredFields.push('session');
    }
    if (this.exam.examinationType == '') {
      this.modelError.push("*Examination Type required");
      this.erroredFields.push('examinationType');
    }
    if (this.exam.duration == 0 && (this.exam.liveProctoring || this.exam.aIProctoring || this.exam.facialRecognition || this.exam.recording) && !this.exam.psychometricTest) {
      this.modelError.push("*Duration required for proctored exam");
      this.erroredFields.push('duration');
    }
    if (this.exam.questionSelectionMode == '') {
      this.modelError.push("*Question Selection Mode required");
      this.erroredFields.push('questionSelectionMode');
    }

    if (this.exam.liveProctoring || this.exam.aIProctoring || this.exam.facialRecognition || this.exam.recording) {
      if (!this.exam.noPrimaryStreamPolicy || this.exam.noPrimaryStreamPolicy === '' || this.exam.noPrimaryStreamPolicy === 'NotSet') {
        this.modelError.push("*Proctoring options No Primary Stream Policy");
        this.setErroredFields(['noPrimaryStreamPolicy'], false);
      }

      if (this.exam.requireSecondView && !this.exam.noSecondViewStreamPolicy) {
        this.modelError.push("*No Second View Stream Policy must be enabled if Require Second View is enabled");
        this.setErroredFields(['noSecondViewStreamPolicy'], false);
      }
    }
    if (this.exam.requireProctorStart) {
      if (!this.exam.liveProctoring) {
        this.modelError.push("*'Live Proctoring' must be enabled to use 'RequireProctorStart'");
        this.setErroredFields(['requireProctorStart'], false);
      }
    }

    if (this.exam.allowExamRetake && (this.exam.maxRetake == 0 || this.exam.answeredQuestionsPercentage == 0 || this.exam.examinationDurationPercentage == 0)) {
      this.modelError.push("*Exam Retake options Max Retake, Answered Questions Percentage and Examination Duration Percentage required");
      this.setErroredFields(['maxRetake', 'answeredQuestionsPercentage', 'examinationDurationPercentage'], false);
    }
    if (this.exam.examStartDate == undefined || new Date() >= this.exam.examStartDate) {
      this.modelError.push("*Invalid Exam Start Date");
      this.erroredFields.push('examStartDate');
    }
    if (this.exam.examEndDate == undefined || new Date() >= this.exam.examEndDate) {
      this.modelError.push("*Invalid Exam End Date");
      this.erroredFields.push('examEndDate');
    }
    if (this.exam.examEndDate < this.exam.examStartDate) {
      this.modelError.push("*End date cannot be before Start Date");
      this.erroredFields.push('examEndDate');
    }
    if (this.exam.selfSchedule && (this.exam.selfRegistrationEndDate == undefined || this.exam.selfRegistrationEndDate > this.exam.examEndDate)) {
      this.modelError.push("*Invalid Self Registration End Date");
      this.erroredFields.push('selfRegistrationEndDate');
    }
    if (this.exam.questionSelectionMode === "RandomPerCategory") {

    }
    if (this.exam.maximumNumberOfEssayAnswers > this.exam.numberOfQuestions && this.exam.examinationType === 'Essay') {
      this.modelError.push("*Maximum number of essay answers cannot exceed number of questions.");
      this.erroredFields.push('maximumNumberOfEssayAnswers');
    }

    if (this.exam.maximumNumberOfSAQAnswers > this.exam.numberOfQuestions && this.exam.examinationType === 'SAQ') {
      this.modelError.push("*Maximum number of SAQ answers cannot exceed number of questions.");
      this.erroredFields.push('maximumNumberOfSAQAnswers');
    }

    if (this.exam.useQuestionBank && this.text === 'Create') {
      const selectedQuestionBanks = this.questionBanks?.filter(cat => cat.selected) || [];

      if (selectedQuestionBanks.length === 0) {
        this.modelError.push("*At least one Question Bank must be selected");
        this.erroredFields.push('questionBanks');

        return
      }

      if (this.exam.psychometricTest) {
        if (selectedQuestionBanks.length > 1) {
          this.modelError.push("*Only one Question Bank can be selected for Psychometric exams");
          this.erroredFields.push('questionBanks');
        }

        // For psychometric exams, user should not fill pool size / number of questions
        const invalidFields = selectedQuestionBanks.filter(qb =>
          qb.questionBankPoolSize ||
          qb.numberOfQuestions
        );

        if (invalidFields.length > 0) {
          this.modelError.push("*Pool size and number of questions are not needed for Psychometric exams");
          this.erroredFields.push('psychometricValidation');
        }

        return;
      }

      let hasInvalidPoolSize = false;
      let hasInvalidQuestionCount = false;
      let totalQuestions = 0;

      for (const selectedQuestionBank of selectedQuestionBanks) {
        // Validate pool size
        if (!selectedQuestionBank.questionBankPoolSize || selectedQuestionBank.questionBankPoolSize <= 0) {
          hasInvalidPoolSize = true;
        } else if (selectedQuestionBank.questionBankPoolSize > 1000) {
          hasInvalidPoolSize = true;
        }

        // Validate number of questions
        if (!selectedQuestionBank.numberOfQuestions || selectedQuestionBank.numberOfQuestions <= 0) {
          hasInvalidQuestionCount = true;
        } else if (selectedQuestionBank.numberOfQuestions > selectedQuestionBank.questionBankPoolSize) {
          hasInvalidQuestionCount = true;
        }

        // Sum total questions for overall validation
        totalQuestions += selectedQuestionBank.numberOfQuestions || 0;
      }

      if (hasInvalidPoolSize) {
        this.modelError.push("*Question Bank Pool size must be between 1 and 1,000 for all selected");
        this.erroredFields.push('questionBankPoolSize');
      }

      if (hasInvalidQuestionCount) {
        this.modelError.push("*Number of questions must be valid and less than pool size for all selected");
        this.erroredFields.push('noOfQuestions');
      }
    }
    if (this.erroredFields.length > 0) {
      this.setErroredFields(this.erroredFields);
    }
  }

  onEditClicked() {
    this.disableAll = false;
    this.text = 'Update'
  }

  steps: string[] = [
    'Basic Info',
    'Question Settings',
    'Questions Bank Setup',
    'Security',
    'Proctoring',
    'Instructions',
    'Others',
  ];
  currentStep: number = 0;

  nextStep() {
    if (this.currentStep < this.steps.length - 1) this.currentStep++;
  }

  prevStep() {
    if (this.currentStep > 0) this.currentStep--;
  }

  nextTab(currentIndex) {
    const nextTabTrigger = document.querySelector(`#tab${currentIndex + 1}`) as HTMLElement;
    if (nextTabTrigger) nextTabTrigger.click();
  }

  prevTab(currentIndex) {
    const prevTabTrigger = document.querySelector(`#tab${currentIndex - 1}`) as HTMLElement;
    if (prevTabTrigger) prevTabTrigger.click();
  }

  setErroredFields(ids: string[], gotoPrevTab: boolean = true) {
    ids.forEach(id => {
      const element = document.getElementById(id);
      if (element) {
        element.classList.add('errored-field');
      }
    });
    if (gotoPrevTab) {
      this.prevTab(1);
    }
  }
  removeErroredFields(ids: string[]) {
    ids.forEach(id => {
      const element = document.getElementById(id);
      if (element) {
        element.classList.remove('errored-field');
      }
    });

  }

  async onUseQuestionBankChange() {
    if (this.exam.useQuestionBank) {
      this.snackBar.warning("Questions are auto added, when exam question bank are added")

      await this.getQuestionBanks();
    }
  }

  private async getQuestionBanks() {
    if (this.text != 'Create') {
      return;
    }

    if (this.allQuestionBanks.length === 0 || this.oldExaminationType != this.exam.examinationType) {
      this.allQuestionBanks = await this.questionBankService.getQuestionBanksLookup(this.exam.examinationType, null, this.exam.psychometricTest);
    }

    this.filterQuestionBanks();
  }

  toggleAllQuestionBanks(event: any) {
    const isChecked = event.target.checked;
    this.questionBanks.forEach(bank => {
      bank.selected = isChecked;
    });
  }

  onPoolSizeChange(value: number, bank: any): void {
    if (value == null || isNaN(value)) {
      bank.questionBankPoolSize = 0;
      return;
    }

    // Apply constraints
    if (value < 0) {
      bank.questionBankPoolSize = 0;
    } else if (value > 1000) {
      bank.questionBankPoolSize = 1000;
    } else {
      bank.questionBankPoolSize = Math.floor(value); // Ensure integer values
    }

    // Adjust noOfQuestions if it exceeds the new pool size
    if (bank.noOfQuestions >= bank.questionBankPoolSize && bank.questionBankPoolSize > 0) {
      bank.noOfQuestions = bank.questionBankPoolSize - 1;
    }
  }

  onNoOfQuestionsChange(value: number, cat: any): void {
    if (value == null || value < 0) {
      cat.noOfQuestions = 0;
    } else if (cat.questionBankPoolSize > 0 && value >= cat.questionBankPoolSize) {
      cat.noOfQuestions = cat.questionBankPoolSize - 1;
    } else {
      cat.noOfQuestions = Math.floor(value);
    }
  }

  getMaxQuestions(cat: any): number {
    return cat.questionBankPoolSize > 0 ? cat.questionBankPoolSize - 1 : 0;
  }

  private updateExamWithSelectedQuestionBanks(): void {
    if (this.exam.useQuestionBank && this.questionBanks) {
      // Filter only selected QBs
      const selectedQuestionBanks = this.questionBanks.filter(f => f.selected);

      // Map to the DTO format and assign to exam object
      this.exam.examQuestionBanks = selectedQuestionBanks.map(m => ({
        name: m.name,
        questionBankPoolSize: m.questionBankPoolSize || 0,
        selected: m.selected,
        totalNumberOfQuestions: m.totalNumberOfQuestions || 0,
        isWebTestBank: m.isWebTestBank || false,
        questionBankID: m.questionBankID,
        category: m.category,
        numberOfQuestions: m.numberOfQuestions,
        disabled: false,
        examinationID: 0,
        id: 0,
        questionBankSource: "",
        isPsychometricTestBank: false
      }));
    } else {
      // Clear the question banks is not used
      this.exam.examQuestionBanks = [];
    }
  }

  get hasWebTestQuestionBank(): boolean {
    return this.allQuestionBanks?.some(qb => qb.isWebTestBank);
  }
  onPsychometricTestChange() {
    if (this.exam.psychometricTest) {
      this.exam.examinationType = "MultipleChoice";
      this.exam.useQuestionBank = true;
      this.exam.questionSelectionMode = "All";
      this.exam.duration = 0;
      this.onUseQuestionBankChange()
    } else {
      this.exam.useQuestionBank = false;
    }
  }

  onBankSelectionChange(bank: any) {
    if (!this.exam.psychometricTest) {
      return;
    }

    this.exam.numberOfQuestions = bank.totalNumberOfQuestions;

    const selected = this.questionBanks.filter(qb => qb.selected);

    if (selected.length > 1) {
      bank.selected = false;
      this.snackBar.error("Only one Question Bank can be selected for Psychometric Tests");
    }
  }

  get selectedPsychometricBankCount(): number {
    return this.questionBanks?.filter(qb => qb.selected).length || 0;
  }

  onScheduleFileChange(event: any) {
    if (event.target.files && event.target.files[0]) {
      this.exam.scheduleFile = event.target.files[0];
    }
  }
  onQuestionFileChange(event: any) {
    if (event.target.files && event.target.files[0]) {
      this.exam.questionFile = event.target.files[0];
    }
  }
  onEditorReady(quill: any) {
    this.quill = quill;
  }
  copyPlaceholder(text: string, event: MouseEvent) {
    navigator.clipboard.writeText(text);
    // Insert into Quill at cursor position
    this.insertIntoQuill(text);
    const target = event.target as HTMLElement;
    const rect = target.getBoundingClientRect();

    // Position toast beside the span
    this.toast.x = rect.right + 10; // 10px to the right
    this.toast.y = rect.top;

    this.toast.visible = true;

    // Hide after 1.2 seconds
    setTimeout(() => {
      this.toast.visible = false;
    }, 1200);
  }

  insertIntoQuill(text: string) {
    if (!this.quill) return;

    const range = this.editor.quillEditor.getSelection(true);

    if (range) {
      // Insert text at cursor
      this.editor.quillEditor.insertText(range.index, text);

      // Move cursor to end of inserted text
      this.editor.quillEditor.setSelection(range.index + text.length, 0);
    } else {
      // If no cursor (editor not focused), append at end
      const length = this.editor.quillEditor.getLength();
      this.editor.quillEditor.insertText(length, text);
    }
    this.exam.emailMessage = this.quill.root.innerHTML;

  }
}
